import React from 'react';
import ImageZoom from 'react-medium-image-zoom';

import coverImg from '../../imgs/Onboarding/coverImg-Amp.png';
import ampai from '../../imgs/Onboarding/ampai.png';
import keyproblem from '../../imgs/Onboarding/keyproblem.jpg';
import personaryan from '../../imgs/Onboarding/persona-ryan.jpg';
import personajosh from '../../imgs/Onboarding/persona-josh.jpg';
import userstories from '../../imgs/Onboarding/userstories.png';
import brainstorm from '../../imgs/Onboarding/brainstorming.png';
import taskflow from '../../imgs/Onboarding/onboardingtaskflow.png';
import sketches1 from '../../imgs/Onboarding/sketches1.png';
import sketches2 from '../../imgs/Onboarding/sketches2.png';
import whiteboarding from '../../imgs/Onboarding/sketching.png';
import states from '../../imgs/Onboarding/states.png';
import helper from '../../imgs/Onboarding/red-dot-anima.gif';
import style from '../../imgs/Onboarding/markup.jpg';
import modal from '../../imgs/Onboarding/modal.png';
// import email from '../../imgs/Onboarding/email.png';
import wireframe from '../../imgs/Onboarding/wireframe.gif';
// import mockups from '../../imgs/Onboarding/mockups.png';

const SIOnboarding = () => (
  <div className="caseBody">
    <section className="head">
      <h2>Amp.ai Onboarding Experience Design</h2>
      <p className="caseIntro">Scaled Inference</p>
      <img className="img-responsive img-centered" src={coverImg} alt="" />
    </section>

    <section className="mainSec">
      <div className="left">
        <h3 id="overview">Project Overview</h3>
      </div>
      <div className="right">
        <h4>BACKGROUND</h4>
        <p className="content-p">
          <b>Amp.ai</b> is the flagship product of Scaled Inference. It’s an
          AI-powered optimization platform that delivers personal experiences at
          scale to drive metrics and business growth.
        </p>
        <ImageZoom
          image={{
            src: ampai,
            alt: 'different states',
            className: 'img-responsive img-centered'
          }}
        />
        <h4>CHALLENGES</h4>
        <p className="content-p">
          Onboarding is one of the most critical elements of every product. One
          of the major challenge is that due to the nature of the product, the
          Onboarding process can take several days to accomplish and it may
          require efforts from more than one user.
        </p>
        <div className="fullWidth">
          <ImageZoom
            image={{
              src: keyproblem,
              alt: 'keyproblem',
              className: 'img-responsive img-centered'
            }}
          />
        </div>
        <h4 id="myRoles">GOALS</h4>
        <p className="content-p">
          Provide <strong>seamless Onboarding user experience</strong> for
          people who came through the funnel.
        </p>
        <p className="content-p">
          The Onboarding experience should <strong>provide guidance</strong> as
          they go.
        </p>
        <p className="content-p">
          <strong>Increase user engagement</strong> and keep them in the loop
          until their projects are ready to optimize.
        </p>

        <h4 id="myRoles">MY ROLE</h4>
        <p className="content-p">
          Product Designer - From brainstorming to the final interactive
          prototype, I was responsible for the whole Onboarding experience. On
          product level, I designed features across entire product flow,
          conducted user research to understand users and to improve the user
          experience.
        </p>
        <h4>HIGHLIGHTS</h4>
        <p className="content-p p-check">
          I worked with stakeholders and developers to develop new features for
          the onboarding process. I led iterations and tracked how designs were
          implemented.
        </p>
        <p className="content-p p-check">
          I proposed designs of the three key features and the feedback is
          positive.
        </p>
        <p className="content-p p-check">
          I took initiative to conduct usability test and integrate user testing
          tool with Amp.ai to locate pain points and uncover needs.
        </p>
        <p className="content-p p-check">
          Being proficient in design tools, I made all the mockups and protypes
          on my own. I created the status email template and helped code in
          HTML/CSS.
        </p>
        <p className="content-p p-check">
          I aligned the product vision with company vision and goals.
        </p>
        <h4>TOOLS</h4>
        <p className="content-p">
          Sketch, InVision, Google Docs + Google Slides, Confluence, Jira,
          Inspectlet
        </p>
      </div>
    </section>
    <section className="mainSec">
      <div className="left">
        <h3 id="research">Research</h3>
      </div>
      <div className="right">
        <h4>USER STUDIES</h4>
        <p className="content-p">
          I did some research on 5 users who have experience using Amp.ai. I
          also watched individual visitors using the product and studied their
          mouse movement. During the process, I learnt how they used the console
          to set up projects. From there, I discovered their main pain points.
        </p>
        <p className="content-p">
          <b>Pain Points</b>
        </p>
        <p className="content-p">
          1. How many steps left? Where am I supposed to click?
        </p>
        <p className="content-p">
          Users always found themselves lost track of steps. After several
          steps, they felt confused and left the console.
        </p>
        <p className="content-p">
          We didn’t provide them with enough guidance and support. Users didn’t
          know where to click.
        </p>
        <p className="content-p">2. What does it mean?</p>
        <p className="content-p">
          Some concept/terminologies are hard to understand at first glance. We
          did poorly on explaining and introducing concept.
        </p>
        <h4>PERSONA</h4>
        <p className="content-p">
          Project managers and developers are our major target user groups. I
          built these two personas based on my previous user studies. They serve
          as a touch-point to return to when I’m working through the mental
          modeling of each user as they set up the project for the first time.
        </p>
        <p className="content-p">
          Ryan is a project manager in a tech company. He’s comfortable using
          Google Analytics and A/B testing. He’s not familiar with machine
          learning. He’s willing to try out new tech and he’s looking for ways
          to get conclusive results from testing.
        </p>
        <ImageZoom
          image={{
            src: personaryan,
            alt: 'persona',
            className: 'img-responsive img-centered'
          }}
        />
        <p className="content-p">
          Josh is a developer and he’s experienced with integrating A/B Testing.
          He usually has to go back and forth with the integration.
        </p>
        <ImageZoom
          image={{
            src: personajosh,
            alt: 'persona',
            className: 'img-responsive img-centered'
          }}
        />

        <h4>USER STORIES</h4>
        <p className="content-p">
          Using what we knew of the 2 personas and what we could glean from a
          quick review of the marketing materials, I began drafting a series of
          user stories that covered the key flows for the User Onboarding.
        </p>
        <p className="content-p">
          <b>As a [User Type] I want to [Task] so that I can [Why].</b>
        </p>
        <p className="content-p">
          After prioritization on the part of stakeholders, selected user
          stories will be added and tracked in Jira throughout the production
          sprints. Here is an example:
        </p>
        <ImageZoom
          image={{
            src: userstories,
            alt: 'userstories',
            className: 'img-responsive img-centered'
          }}
        />
        <h4>GROUP BRAINSTORMING</h4>
        <p className="content-p">
          I synthesized the research notes into insights and sat with my team to
          discuss and brainstorm possible ways of improving the overall
          Onboarding process.
        </p>
        <ImageZoom
          image={{
            src: brainstorm,
            alt: 'brainstorm',
            className: 'img-responsive img-centered'
          }}
        />
        <h4>TASK FLOW</h4>
        <p className="content-p">
          I took the lead on creating high-level Task Flow, which shows common
          task flows completed by users in their interaction travels through the
          product. With the prioritization of user stories and key features, the
          task flow will represent key user tasks that underline each
          prioritized feature that should be introduced during the Onboarding
          experience.
        </p>
        <div className="fullWidth">
          <ImageZoom
            image={{
              src: taskflow,
              alt: 'taskflow',
              className: 'img-responsive img-centered'
            }}
          />
        </div>
      </div>
    </section>

    <section className="mainSec">
      <div className="left">
        <h3 id="design">Design</h3>
      </div>

      <div className="right">
        <h4>SKETCHES AND WHITEBOARDING</h4>
        <p className="content-p">
          I did some early sketching, whiteboarding and brainstorming for the
          Onboarding design project. All the designs were based on interview
          feedback and analysis. I used these low-fidelity sketches as a
          starting point for group discussions and presentations.
        </p>
        <ImageZoom
          image={{
            src: sketches1,
            alt: 'sketches',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: sketches2,
            alt: 'sketches',
            className: 'img-responsive img-centered'
          }}
        />
        <ImageZoom
          image={{
            src: whiteboarding,
            alt: 'whiteboarding',
            className: 'img-responsive img-centered'
          }}
        />
        <h4>MINIMUM VIABLE PRODUCT</h4>
        <p className="content-p">
          The timelines were tight so we decided to focus on three parts of the
          Onboarding experience and show prompts when users are in different
          states. Here are different states:
        </p>
        <ImageZoom
          image={{
            src: states,
            alt: 'different states',
            className: 'img-responsive img-centered'
          }}
        />
        <p className="content-p p-check">
          <b>How to guide users </b>
        </p>
        <p className="content-p">
          Static up-front tutorials are pretty common practice and can be easy
          to implement. However, there are a number of reasons to not adopt it.
          We can’t expect users to read all the tutorials before using the
          product. Users may as well just try out the app themselves but the
          tutorials are road blocks for people who want to experience the
          product.
        </p>
        <p className="content-p">
          Study shows that 90% of knowledge people get is a result of practical
          experience. Rather than making users remember everything in the
          beginning, we should support them as they use the product. Therefore,
          I decided to use a contextual approach and provide useful information
          at the point of user action.
        </p>
        <p className="content-p">
          I use <strong>red dots</strong> to indicate major steps. Users need to
          complete these 7 essential steps to get their project fully
          functioned. As they follow the steps, the consoles shows them
          additional prompts that introduce new concepts/ features.
        </p>
        <p className="content-p">
          Onboarding should be detached from the product itself and I try to
          avoid throwing too much information all at once with education
          carousel. Instead, doing the Onboarding interactively will help users
          learn faster and familiarize themselves with the process.
        </p>
        <ImageZoom
          image={{
            src: helper,
            alt: 'helper',
            className: 'img-responsive img-centered'
          }}
        />
        <p className="content-p">
          Our team decided to use a playful handwriting typeface for all the
          tooltips due to the fact that the process can be long and tedious.
        </p>
        <ImageZoom
          image={{
            src: style,
            alt: 'markup',
            className: 'img-responsive img-centered'
          }}
        />
        <p className="content-p p-check">
          <b>How to keep track on progress </b>
        </p>
        <p className="content-p">
          Progress Indicator persists in the console main page. It shows where
          the user is at the moment and when user clicks on it, a modal will pop
          up and provide instructions.
        </p>
        <ImageZoom
          image={{
            src: modal,
            alt: 'modal',
            className: 'img-responsive img-centered'
          }}
        />
        <p className="content-p p-check">
          <b>How to keep users posted </b>
        </p>
        <p className="content-p">
          Since the whole process may take up to days, I designed the status
          email template to keep users posted. We will send out emails
          automatically on daily basis and encourages them check back the
          console. They can finish the setup at their own pace.
        </p>
        {/* <ImageZoom
          image={{
            src: email,
            alt: 'email',
            className: 'img-responsive img-centered'
          }}
        /> */}
        <h4>WIREFRAMES ANE EXPERIENCE DESIGN</h4>
        <p className="content-p">
          I ideated potential solutions that address user’s pain points and
          evaluate the ideations.
        </p>
        <p className="content-p">
          Following is an interactive prototype with interface click through to
          explain the user journey for the user Onboarding experience.
        </p>
        <ImageZoom
          image={{
            src: wireframe,
            alt: 'wireframe',
            className: 'img-responsive img-centered'
          }}
        />
        <a
          className="demo-link"
          href="https://invis.io/NXN375NTHMU"
          rel="noopenner noreferrer"
          target="_blank"
        >
          Try Prototype →
        </a>
      </div>
    </section>

    <section className="mainSec">
      <div className="left">
        <h3 id="lessons">Reflection</h3>
      </div>
      <div className="right">
        <p className="content-p p-check">
          In engaging ourselves with an in-depth process, our team finished the
          Onboarding feature from design to implementation in a short amount of
          time.
        </p>
        <p className="content-p p-check">
          I learned that how to balance business goals and user experience under
          time and Resource constraints and it’s necessary to make trade-offs.
        </p>
        <p className="content-p p-check">
          The product can’t be perfect by any means. After making sure it works
          properly and it’s functioning, we should release it instead of holding
          back and doing test in house.
        </p>
        <p className="content-p p-check">
          I honed my communication skills when collaborating across disciplines.
        </p>
      </div>
    </section>
  </div>
);

export default SIOnboarding;



// WEBPACK FOOTER //
// ./src/Modules/Case/SIOnboarding.js